<script>
import verificarAssinaturaService from './servico';
import radio from '~componentes/Radio.vue';
import { checkbox } from 'vue-strap';
import FileInput from '~componentes/InputFile.vue'

export default {
  components: { radio, checkbox, FileInput },
  data() {
    return {
      carregando: false,
      texto: '',
      arquivo: null,
      mostrarResultado: false,
      textoSHA256: '',
      textoSHA512: '',
      arquivoSHA256: '',
      arquivoSHA512: '',
    }
  },
  mounted() {
    this.$root.tituloDaPagina = 'Verificação de assinaturas';
  },
  methods: {
    async enviar() {
      $('#enviar').button('loading');

      const valido = await this.validar();
      if (valido) {
        try {
          await verificarAssinaturaService.verificarAssinatura(
            this.texto, this.arquivo).then(response => {
              console.log("response => ", response.data);
              this.textoSHA256 = response.data.textoHashSHA256;
              this.textoSHA512 = response.data.textoHashSHA512;
              this.arquivoSHA256 = response.data.arquivoHashSHA256;
              this.arquivoSHA512 = response.data.arquivoHashSHA512;
            });
          this.mostrarResultado = true;
        } catch (e) {
          this.$swal('', 'Erro ao verificar assinatura.', 'error');
        }
      } else {
        this.$swal('', 'Por favor, corrija os erros no formulário.', 'error');
      }
      $('#enviar').button('reset');
    },
    validar() {
      return this.$validator.validateAll();
    },
    limpar() {
      this.texto = '';
      this.arquivo = null;
      this.$refs.fileInput.removerArquivo();
      this.mostrarResultado = false;
    },
    validarArquivo() {
      if (this.arquivo != null) {
        if (this.arquivo.name != null && this.arquivo.name != '' && typeof this.arquivo.name !== 'undefined') {
          return '';
        }
      }
      return 'required';
    },
  }
}
</script>

<style>
.box-verificar {
  width: 100%;
  padding: 10px 10% 0 10%;
}
</style>

<template>
  <div class="box-verificar">

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{ 'has-error': errors.has('mensagemTexto') }">
          <label class="control-label text-white" for="mensagemTexto">Texto</label>

          <textarea class="form-control" id="mensagemTexto" v-model="texto" data-vv-name="mensagemTexto"
            data-vv-as="texto" v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('mensagemTexto')">{{ errors.first('mensagemTexto') }}</p>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{ 'has-error': errors.has('mensagemArquivo') }">

          <label class="control-label text-white" for="mensagemArquivo">Arquivo</label>

          <file-input data-vv-name="mensagemArquivo" id="mensagemArquivo" data-vv-as="arquivo" v-model="arquivo"
            ref="fileInput" v-validate="validarArquivo()">

          </file-input>
          <p class="text-danger" v-show="errors.has('mensagemArquivo')">{{ errors.first('mensagemArquivo') }}</p>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-xs-12 align-left flex-items-left align-content-left">

        <button id="enviar" type="button" class="btn btn-primary" @click="enviar()">
          Enviar
        </button>

        <button type="button" class="btn btn-default margin-right-20" @click="limpar()">
          Limpar
        </button>

      </div>
    </div>

    <div class="table-responsive" style="padding-top: 20px;" v-if="mostrarResultado">
      <table class="table relatorio table-bordered">
        <thead>
          <tr>
            <th></th>
            <th>Texto</th>
          </tr>
        </thead>
        <tbody class="text-white">
          <tr>
            <td>SHA256</td>
            <td>{{ textoSHA256 }}</td>
          </tr>
          <tr>
            <td>SHA512</td>
            <td>{{ textoSHA512 }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-responsive" style="padding-top: 20px;" v-if="mostrarResultado">
      <table class="table relatorio table-bordered">
        <thead>
          <tr>
            <th></th>
            <th>Arquivo</th>
          </tr>
        </thead>
        <tbody class="text-white">
          <tr>
            <td>SHA256</td>
            <td>{{ arquivoSHA256 }}</td>
          </tr>
          <tr>
            <td>SHA512</td>
            <td>{{ arquivoSHA512 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/verificar-assinaturas/VerificarAssinaturas.vue